import React from "react";
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  TextField 
} from "@mui/material";

export default function BasicInfoCard({ templateState, setTemplateState, errors = {} }) {
  return (
    <Card 
      sx={{ 
        bgcolor: 'white', 
        border: '1px solid', 
        borderColor: 'grey.200', 
        borderRadius: 3, 
        p: 0, 
        boxShadow: 1 
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography 
          variant="h6" 
          component="h2" 
          sx={{ 
            fontWeight: 'bold', 
            color: 'grey.900', 
            mb: 3 
          }}
        >
          Basic Information
        </Typography>

        <Box>
          <TextField
            fullWidth
            label="Template Name *"
            placeholder="e.g., Professional Blue"
            value={templateState.templateName}
            onChange={(e) =>
              setTemplateState({ ...templateState, templateName: e.target.value })
            }
            error={!!errors.templateName}
            helperText={errors.templateName}
            sx={{ mb: 2 }}
            variant="outlined"
            size="medium"
          />
        </Box>
      </CardContent>
    </Card>
  );
}